
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * AetTextInputFieldStyle
 *
 * @file AetTextInputFieldStyle.jsx
 * @author Anuja Gaikwad
 */


import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';

const useStyles = makeStyles(() => ({
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%'
  },
  label: {
    fontWeight: mixins.fontWeight400,
    fontSize: 14,
    fontFamily: mixins.fontFamilyPlusSans,
    color: mixins.greyScaleColor,
    lineHeight: '22px'
  },
  textInputContainer: {
    position: 'relative',
    maxWidth: '100%'
  },
  disabledTextfield: {
    '& .MuiInputBase-root': {
      backgroundColor: mixins.bulkEditCtaButtonDisabledBGColor,
      borderRadius: 4,
      border: `1px solid ${mixins.disabledInputBoxColor}`,
      cursor: 'not-allowed'
    }
  },
  disabledTextInput: {
    '&&': {
      color: mixins.bulkEditCtaButtonDisabledColor
    }
  },
  outlinedInputRoot: {
    height: 48,
    borderRadius: 4,
    padding: 12,
    backgroundColor: '#FFFFFF',
    width: '100%',
    maxWidth: 'var(--form-fields-max-width, 100%)',

    '& $notchedOutline': {
      borderColor: mixins.amethyst
    },
    '&:hover $notchedOutline': {
      borderColor: mixins.amethyst
    },
    '&$focused $notchedOutline': {
      borderColor: mixins.amethyst,
      borderWidth: 2
    },
    '&$error $notchedOutline': {
      borderColor: mixins.darkNeedsReviewBgColor
    },
    '&$error:hover $notchedOutline': {
      borderColor: mixins.darkNeedsReviewBgColor
    },
    '&$error$focused $notchedOutline': {
      borderColor: mixins.darkNeedsReviewBgColor,
      borderWidth: 2
    }
  },
  focused: {},
  error: {},
  notchedOutline: {},
  outlinedInput: {
    padding: 0,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight400,
    fontFamily: mixins.fontFamilyPlusSans,
    color: mixins.greyScaleColor,
    lineHeight: 24
  },
  formHelperText: {
    marginTop: 4,
    marginLeft: 0
  },
  errorText: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    color: mixins.accentRed,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: 12,
    fontWeight: mixins.fontWeight500,
    lineHeight: '20px'
  },
  helperText: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    color: mixins.zambezi,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: 12,
    fontWeight: mixins.fontWeight500,
    lineHeight: '20px'
  },
  errorIcon: {
    fontSize: 16
  },
  editIconContainer: {
    padding: '0px',
    marginRight: '0px',

    '&:hover': {
      background: 'none',
      cursor: 'default'
    }
  }
}));

export default useStyles;
